import './Loader2.css';

const Loader2 = () => {
    return (
        <div className='loader2'></div>
    )
}

export default Loader2;